import LOGO from "../assets/images/common/logonew.png"
import DEMO_ACCOUNT from "../assets/images/common/Demo.png"
import LIVE_ACCOUNT from "../assets/images/common/Live.png"

import SUBMIT from "../assets/images/common/Submit.png"
import SUBMIT_CLICK from "../assets/images/common/Submit-click.png"

import HOME_PAGE_BG from "../assets/images/common/home-page-bg.png"
import NEW_MAP_SMALL from "../assets/images/common/new-map-small.png"
import ACCU_ACADEMY from "../assets/images/Pages/Acc-Academy.png"
import LOGIN_ICON from "../assets/images/Pages/LoginIcon.png"

import CALL_BACK_REQUEST from "../assets/images/Pages/Call-Back-Request.png"
import LIVE_CHAT from "../assets/images/Pages/Live-Chat.png"
import PRINCIPLE_INVESTING from "../assets/images/Pages/Principle-Investing.png"

import PRIVACY_POLICY from "../assets/images/Breadcumb/Privacy-Policy.jpg"
import PDF_FILE_ICON from "../assets/images/Pages/PDF_file_icon.png"

import SERVICE_VIDEO from "../assets/videos/service-center.mp4";
import SERVICE_VIDEO2 from "../assets/videos/service-2.mp4";

import AE from "../assets/images/Flags/ae.jpg";
import JA from "../assets/images/Flags/ja.jpg";
import SO from "../assets/images/Flags/so.jpg";
import EN from "../assets/images/Flags/en.jpg";
import RU from "../assets/images/Flags/ru.jpg";
import ES from "../assets/images/Flags/es.jpg";
import FA from "../assets/images/Flags/fa.jpg";
import ZH from "../assets/images/Flags/zh.jpg";

//////Bonus Image
import ICON1 from "../assets/images/bonus/icon1.png";
import ICON2 from "../assets/images/bonus/icon2.png";
import ICON3 from "../assets/images/bonus/icon3.png";
import ICON4 from "../assets/images/bonus/icon4.png";

import ICON1_AR from "../assets/images/bonus/icon1-ar.png";
import ICON2_AR from "../assets/images/bonus/icon2-ar.png";
import ICON3_AR from "../assets/images/bonus/icon3-ar.png";
import ICON4_AR from "../assets/images/bonus/icon4-ar.png";

import ELEMENTS from "../assets/images/bonus/ELEMENTS.png";
import BBG from "../assets/images/bonus/bg.png";

export {
  ICON1_AR,
  ICON2_AR,
  ICON3_AR,
  ICON4_AR,
  ICON1,
  ICON2,
  ICON3,
  ICON4,
  ELEMENTS,
  BBG,
  AE,
  JA,
  RU,
  SO,
  EN,
  ES,
  FA,
  ZH,
  LOGO,
  ACCU_ACADEMY,
  LOGIN_ICON,
  DEMO_ACCOUNT,
  LIVE_ACCOUNT,
  CALL_BACK_REQUEST,
  LIVE_CHAT,
  PRINCIPLE_INVESTING,
  PRIVACY_POLICY,
  HOME_PAGE_BG,
  NEW_MAP_SMALL,
  SUBMIT,
  SUBMIT_CLICK,
  PDF_FILE_ICON,
  SERVICE_VIDEO,
  SERVICE_VIDEO2
}
